import { api } from "./api";

function vid() {
  let v = localStorage.getItem("jc_vid");
  if (!v) { v = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("jc_vid", v); }
  return v;
}
function sid() {
  let s = sessionStorage.getItem("jc_sid");
  if (!s) { s = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("jc_sid", s); }
  return s;
}

export function track(event, path, extra = {}) {
  try {
    api.post("/track", {
      event,
      path: path || window.location.pathname,
      visitor_id: vid(),
      session_id: sid(),
      referrer: document.referrer || "",
      ...extra,
    }).catch(() => {});
  } catch { /* never block UX */ }
}

export function trackPageView(path) { track("page_view", path); }

export function trackPing(path) {
  try {
    api.post("/track/ping", { visitor_id: vid(), session_id: sid(), path: path || window.location.pathname }).catch(() => {});
  } catch { /* noop */ }
}
